export default __webpack_public_path__ + "static/media/Logo.e31d3234.png";